import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import MasterLayout from '../AppLayout/MasterLayout';
import CollectionsAppLayout from '../AppLayout/Collections/CollectionsAppLayout';
import CollectionsTabs from '../AppLayout/Collections/CollectionsTabs';
import { routes } from '../../constants';
import EmptySearchStateImage from '../Search/SearchResults/EmptySearchResultsNewUI/EmptySearchStateImage';
import { Link } from 'found';
import { customSizes } from '../../assets/styles/themes/tokens';
import { CollectionFormModalContext } from '../../state/CollectionFormModalProvider';
import MyCollectionsAddButton from './MyCollectionsAddButton';
import { AsyncActionStatus } from '../../actions/common.actionTypes';
import { CollectionProperties } from '../../types/AppContent';
import MyCollectionsList from './MyCollectionsList';
import useResponsivePadding from '../../utils/useResponsivePadding';

interface MyCollectionsProps {
  collectionsStatus: AsyncActionStatus;
  collections: CollectionProperties[];
}

const MyCollections: React.FC<MyCollectionsProps> = (props) => {
  const { collectionsStatus, collections } = props;
  const { t } = useTranslation();
  const { show: openCollectionFormModal } = useContext(CollectionFormModalContext);
  const contentPadding = useResponsivePadding();

  const renderMyCollections = () => {
    if (collectionsStatus !== 'loading' && (!collections || !collections.length)) {
      return (          
        <EmptySearchStateImage
          title={t('no collections yet')}
          subtitle={
            <Trans 
              i18nKey='Create your own collection or follow curated collections' 
              key={1}
            >
              <Link to={`/${routes.curatedCollections.root}`}></Link>
            </Trans>
          }
          subtitleSx={{ maxWidth: customSizes.emptyStateSubtitleMaxWidth, textAlign: 'center' }}
          iconName='emptyState'
        />
      );
    }

    return <MyCollectionsList collections={collections} />;
  };

  return (
    <Box data-testid='own-collection-overview-page'>
      <MasterLayout isNewMerklistePage={true}>
        <CollectionsAppLayout
          title={t('Saved')}
          tabs={
            <CollectionsTabs
              activeTab={routes.collections.root}
              isNewDesignEnabled={true}
            />
          }
          isSearchPageContainer={true}
          headerButton={<MyCollectionsAddButton openCollectionFormModal={() => openCollectionFormModal()} />}
        >
          <Box sx={{ padding: contentPadding }}>
            {renderMyCollections()}
          </Box>
        </CollectionsAppLayout>
      </MasterLayout>
    </Box>
  );
};

export default MyCollections;
